import styled from "styled-components";

export const FallbackImageSection = styled.div.attrs({
  className: "relative flex h-full w-full items-center justify-center p-[16%]",
})``;
